import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import azTranslation from "./locales/az/translation.json";
import enTranslation from "./locales/en/translation.json";
import deTranslation from "./locales/de/translation.json";
import esTranslation from "./locales/es/translation.json";

const resources = {
  az: { translation: azTranslation },
  en: { translation: enTranslation },
  de: { translation: deTranslation },
  es: { translation: esTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "az",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["cookie", "localStorage"],
      caches: ["cookie"],
      lookupCookie: "lux_store_lang",
      cookieMinutes: 525600,
    },
  });

export default i18n;
